// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Mheom","title":"styles_title__w0R7U","description":"styles_description__RBer+","content":"styles_content__TJuR2"};